export const cusFollowOpBlickList = new Set(['transfer', 'close']);
